export var GET_ALL_DISPLAY_REQUEST = "display/getAllDisplayRequest";
export var GET_DISPLAY_REQUEST = "display/getDisplayRequest";
